<template>
  <div>    
      <div class="row">
        <div class="col-md-12" style="margin-top: -40px;">
            <graficopie :rotulo="'DETALHES:'"
                        :legendas="legendasbairros"
                        :dados="dadosbairros"
            ></graficopie>
        </div>
        <div class="col-md-12">
            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                <li v-for="(item, indice) in dadosbairros" :key="indice" class="li-item-card-dash" style="height: 15px;">
                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                    <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(item.totalgeralvendas) * 100, '') }}%)
                    </span>
                </li>
            </ul>                                            
        </div>
      </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoPie from '../../components/cmpgraficopie.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "vendasmunicipios",

  components:{
    'graficopie'		: GraficoPie,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        legendasmunicipios : [],
        isloading               : false,  
        usuariologado           : this.$store.state.usuario,
        dadosbairros            : [],
        legendasbairros         : []

    }
   
  },
  props: [
     'utodasfiliais',
     'idfilialmeta',
     'pdtini',
     'pdtfim',
     'lstfiliais',
    
  ],
  methods:{
        mtdformatavalordecimal(valor){
            return util.formatarvalor(valor, '');
        },
        
        mtdresultadofaturamento(){
            var vself           = this;
        
            vself.$emit('handlerLoader', true);
            let periodo         = '"' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
        

            let parametros      = [
                {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                {parametro: 'op',           valor : 'dash'},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                    
                {parametro: 'periodo',      valor : periodo},
                {parametro: 'usuariologado',valor : JSON.stringify(vself.usuariologado)},
                {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
                {parametro: 'diasemana',    valor : util.diasemanaintmysql()},
                {parametro: 'filtrotarefas',valor : ''},//' and t.sttarefa=0'},
                {parametro: 'patharquivos', valor : ''},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/dashboard.php');
            retorno.then(function (response) {
                
                vself.dadosbairros    = response.data.vendasbairros;
                vself.legendasbairros  = util.gerardadoslegendagrafico(vself.dadosbairros);
            
                vself.$emit('handlerLoader', false);										
            }).catch(function (response) {
                vself.dadosbairros            = [];
                //loader.hide();
                vself.$emit('handlerLoader', false);	
            });                
        },
  },
  mounted(){


    setTimeout(() => {
         this.mtdresultadofaturamento();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
